// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChevronsDownUp as RawChevronsDownUp } from "lucide-react";
export const ChevronsDownUp = /* @__PURE__ */ createIcon(RawChevronsDownUp, "ChevronsDownUp", 2);
